/**
 * インフルエンサー報酬額計算ユーティリティ
 *
 * 計算式: インフルエンサー報酬額 = 広告主支払額 × 59.79%
 *
 * 内訳:
 * - プラットフォーム手数料: 30%
 * - 源泉徴収額: 10.21%
 * - 計算: 100% - 30% - 10.21% = 59.79%
 *
 * 端数処理: 切り捨て
 */

// 報酬額計算用定数
export const PLATFORM_FEE_RATE = 0.3; // 30%
export const TAX_WITHHOLDING_RATE = 0.1021; // 10.21%

/**
 * プラットフォーム手数料を計算する
 * @param customPrice 広告主支払額
 * @returns プラットフォーム手数料（切り捨て）
 */
export const calculatePlatformFee = (customPrice: number): number => {
  if (customPrice <= 0) return 0;
  return Math.floor(customPrice * PLATFORM_FEE_RATE);
};

/**
 * 源泉徴収額を計算する
 * @param customPrice 広告主支払額
 * @returns 源泉徴収額（切り捨て）
 */
export const calculateTaxWithholding = (customPrice: number): number => {
  if (customPrice <= 0) return 0;
  return Math.floor(customPrice * TAX_WITHHOLDING_RATE);
};

/**
 * インフルエンサー報酬額を計算する
 * @param customPrice 広告主支払額
 * @returns インフルエンサー報酬額（手数料・源泉徴収控除後）
 */
export const calculateInfluencerReward = (customPrice: number): number => {
  if (customPrice <= 0) return 0;
  const platformFee = calculatePlatformFee(customPrice);
  const taxWithholding = calculateTaxWithholding(customPrice);
  return customPrice - platformFee - taxWithholding;
};
